export default function Configure($stateProvider) {
    $stateProvider.state('type-bennes', {
        parent: 'gestion',
        url: '/type-bennes',
        //abstract: true,
        views: {
            gestion: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            // le state étant parent et abstract, on décide de ne pas l'afficher dans le fil d'ariane
            //skip: true
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('type-bennes.list', {
        url: '/list',
        template: '<type-bennes></type-bennes>',
        rights: { domain: 'benne', right: 'read' },
        ncyBreadcrumb: {
            label: '{{ "TYPEBENNES.BREADCRUMBS.TYPEBENNES_LIST" | translate}}'
        },
        // on affiche la liste des bennes dans la navigation
        navigation: {
            menu: 'vehicule',
            translate: 'TYPEBENNES.BREADCRUMBS.TYPEBENNES_LIST',
            order: 5
        },
        // la liste des bennes fait partie des points d'entrée recherchables dans la navigation
        search: 'TYPEBENNES.BREADCRUMBS.TYPEBENNES_LIST'
    });

    $stateProvider.state('type-bennes.list.detail', {
        url: '/{id}',
        template: '<type-benne-detail></type-benne-detail>',
        rights: { domain: 'benne', right: 'read' },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher bennes > détail
            parent: 'type-bennes.list',
            label: '{{ "TYPEBENNES.BREADCRUMBS.TYPEBENNE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('type-bennes.new', {
        url: '/new',
        template: '<type-benne-form></type-benne-form>',
        rights: { domain: 'benne', right: 'create' },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher bennes > ajouter
            parent: 'type-bennes.list',
            label: '{{ "TYPEBENNES.BREADCRUMBS.TYPEBENNE_NEW" | translate}}'
        },
        // l'ajout d'un benne fait partie des points d'entrée recherchables dans l'application
        search: 'TYPEBENNES.BREADCRUMBS.TYPEBENNE_NEW'
    });

    $stateProvider.state('type-bennes.edit', {
        url: '/{id}/edit',
        template: '<type-benne-form></type-benne-form>',
        rights: { domain: 'benne', right: 'update' },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher bennes > modifier
            parent: 'type-bennes.list',
            label: '{{ "TYPEBENNES.BREADCRUMBS.TYPEBENNE_EDIT" | translate }}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
